



























import Vue from 'vue';
import Icon from '@/dex-shared/components/Icon.vue';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    entities: {
      type: Array,
      required: true,
    },
  },
});
